import React from 'react';
import { Fab } from '@mui/material';
import AccurityIcon from '../../icon/components/AccurityIcon';
export var ListActionButton = function (_a) {
    var onClick = _a.onClick, children = _a.children;
    return (React.createElement(Fab, { className: "listHeader__fabButton", size: "small", color: "primary", onMouseUp: function (e) { return onClick(e); } }, children ? children : React.createElement(AccurityIcon, { iconName: "mui:Add" })));
};
export default ListActionButton;
//# sourceMappingURL=ListActionButton.js.map